import React, { Component, Fragment } from 'react'
import {NavLink, Link, withRouter} from 'react-router-dom'
import {Icon} from 'react-materialize'

import './NavBar.css'

class NavBar extends Component {
  getNavLinkClass = (path) => {
    return this.props.location.pathname === path ? 'active' : '';
  }

  render() {
    return (
      <Fragment>
        <nav className="nav_main">
          <div className="nav_content">
            <Link to="/" className="brand-logo"><img className="logo_img" src="/salon-app/assets/site/icon.png" alt="hair salon logo" />Hair Salon</Link>
            <a href="# " data-target="mobile-demo" className="sidenav-trigger"><Icon>menu</Icon></a>
            <ul className="right hide-on-med-and-down">
              <li className={this.getNavLinkClass("/")}><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/">Styles</NavLink></li>
              <li><NavLink to="/">Services</NavLink></li>
              <li><NavLink to="/appointments">Appointments</NavLink></li>
              <li><NavLink to="/schedule" style={{fontSize: '1rem'}} className="btn waves-effect waves-orange btn_primary btn_primary-action">Make an Appointment</NavLink></li>
            </ul>
          </div>
        </nav>

         <ul className="sidenav" id="mobile-demo">
          <li className={this.getNavLinkClass("/")}><NavLink to="/">Home</NavLink></li>
          <li><NavLink to="/">Styles</NavLink></li>
          <li><NavLink to="/">Services</NavLink></li>
          <li><NavLink to="/appointments">Appointments</NavLink></li>
          <li><NavLink to="/schedule" style={{fontSize: '1rem'}} className="btn_navlink">Make an Appointment</NavLink></li>
        </ul>
      </Fragment>
    );
  }
}

export default withRouter(NavBar)
